var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:{'has-bottom-padding' : _vm.$route.name !== 'Login'},attrs:{"id":"app"}},[(!_vm.$route.meta.hideHeader)?_c('Header'):_vm._e(),_c('main',{class:{
      'login-page' : _vm.$route.name == 'Login',
      'content-wrapper' : _vm.$route.name != 'Login',
      'document-page' : _vm.$route.name == 'Document',
      'header-large' : _vm.showFilters || _vm.showSearch
    },attrs:{"id":"main","role":"main"}},[_c('router-view')],1),(!_vm.$route.meta.hideFooter)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }